





























































































































































import {OmnichannelFixedGapType, OmnichannelStrategy} from '@/interfaces/server-data';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  components: {
    SwitchWithLabel,
  },
})
export default class OmnichannelIndividualParamsModal extends Vue {
  @Prop({type: Boolean, default: false}) visible!: boolean;

  // --- списки опций ---
  coefficentList: Array<{ label: string; value: any }> = [];
  periodOptions: Array<{ label: string; value: any }> = [];
  kviStrategiesOpts: Array<{ label: string; value: any }> = [];

  // --- значения формы ---
  globalIndividualPriceStrategy: any = '';

  globalIndividualPriceIncreaseLimit: number  = 0;
  globalIndividualPeriodPriceIncreaseLimit: number  = 0;
  globalIndividualPeriod: any = 0;

  globalIndividualMarginalProfitability: number  = 0;
  globalIndividualMarginalErrorText: string = '';

  globalIndividualKviStrategy: any = '';
  globalIndividualPercentageOfCompetitorsPrice: string = '';

  strategy: OmnichannelStrategy  = OmnichannelStrategy.PRICE_EQUALITY;
  strategyParamsType: OmnichannelFixedGapType  = OmnichannelFixedGapType.FIX_GAP
  strategyParamsGap: number  = 0;

  applyCompetitorPrices: boolean = false;
  applyMinProfitabilityLimit: boolean = false;


  get omnichannelStrategiesOptions(): { label: string; value: OmnichannelStrategy }[] {
    return [
      { value: OmnichannelStrategy.PRICE_EQUALITY, label: this.$tc('omnichannelStrategy.strategies.PRICE_EQUALITY') },
      { value: OmnichannelStrategy.FIXED_DIFFERENCE, label: this.$tc('omnichannelStrategy.strategies.FIXED_DIFFERENCE') },
      { value: OmnichannelStrategy.OPTIMAL_DIFFERENCE_ML, label: this.$tc('omnichannelStrategy.strategies.OPTIMAL_DIFFERENCE_ML') },
    ];
  }

  get omnichannelFixedDiffTypeOptions(): { label: string; value: OmnichannelFixedGapType }[] {
    return [
      { value: OmnichannelFixedGapType.FIX_GAP, label: this.$tc('omnichannelStrategy.fixedGapTypes.FIX_GAP') },
      { value: OmnichannelFixedGapType.GREATER_THAN, label: this.$tc('omnichannelStrategy.fixedGapTypes.GREATER_THAN') },
      { value: OmnichannelFixedGapType.LESS_THAN, label: this.$tc('omnichannelStrategy.fixedGapTypes.LESS_THAN') },
      { value: OmnichannelFixedGapType.NOT_GREATER_THAN, label: this.$tc('omnichannelStrategy.fixedGapTypes.NOT_GREATER_THAN') },
      { value: OmnichannelFixedGapType.NOT_LESS_THAN, label: this.$tc('omnichannelStrategy.fixedGapTypes.NOT_LESS_THAN') },
    ];
  }

  get globalIndividualPriceIncreaseLimitValidate(): string {
    const v = this.globalIndividualPriceIncreaseLimit;
    if (v == null) return '';
    return v >= 0 && v < 100 ? '' : 'error';
  }

  get globalIndividualPeriodPriceIncreaseLimitValidate(): string {
    const v = this.globalIndividualPeriodPriceIncreaseLimit;
    if (v == null) return '';
    return v >= 0 && v < 100 ? '' : 'error';
  }

  get globalIndividualMarginalProfitValidate(): string {
    const v = this.globalIndividualMarginalProfitability;
    if (v == null) return '';
    return v < 100 ? '' : 'error';
  }

  get globalIndividualPriceIncreaseLimitBlockButton(): boolean {
    return this.globalIndividualPriceIncreaseLimitValidate === 'error';
  }

  get globalIndividualMarginalBlockButton(): boolean {
    return this.globalIndividualMarginalProfitValidate === 'error';
  }

  get globalIndividualPeriodPriceIncreaseLimitBlockButton(): boolean {
    return this.globalIndividualPeriodPriceIncreaseLimitValidate === 'error';
  }

  saveCalc() {
    // Заглушка: API не вызывается
  }

  onStrategyChanged() {
    // Заглушка: логика смены стратегии (как в OmnichannelStrategyModal) не вызывается
  }

  clearAllGlobalIndividualParams() {
    // this.globalIndividualPriceStrategy = undefined;
    // this.globalIndividualPriceIncreaseLimit = undefined;
    // this.globalIndividualPeriodPriceIncreaseLimit = undefined;
    // this.globalIndividualPeriod = undefined;
    // this.globalIndividualMarginalProfitability = undefined;
    // this.globalIndividualMarginalErrorText = '';
    // this.globalIndividualKviStrategy = undefined;
    // this.globalIndividualPercentageOfCompetitorsPrice = '';
    // this.strategy = undefined;
    // this.strategyParamsType = undefined;
    // this.strategyParamsGap = undefined;
    // this.applyCompetitorPrices = false;
    // this.applyMinProfitabilityLimit = false;
  }

  onOk() {
    this.insertGlobalIndividualParamsForSkuPanel();
    this.$emit('ok');
    this.$emit('update:visible', false);
  }

  onCancel() {
    this.$emit('cancel');
    this.$emit('update:visible', false);
  }

  insertGlobalIndividualParamsForSkuPanel() {
    // Заглушка: вызов API не выполняется
  }
}
